import { joinStringWithDashes } from '@helpers/utils'
import styles from './styles.module.scss'

type RadioProps = {
  value: string
  label: string
  index: string | number
  id: string
  changeValue: (args: Record<string, string>) => void
  unknown?: boolean
  isSelected?: boolean
}

const Radio = ({
  value,
  label,
  index,
  id,
  changeValue,
  unknown = false,
  isSelected = false
}: RadioProps) => {
  const onChange = () => changeValue({ [id]: value })

  return (
    <div
      className={`${styles.radio__inputWrapper} ${
        isSelected ? styles.active : ''
      } ${unknown ? 'unknown' : ''}`}
      tabIndex={Number(index)}
      role="button"
      onKeyDown={onChange}
      onClick={onChange}
      id={`${joinStringWithDashes(id)}-${joinStringWithDashes(value)}`}
    >
      <input
        className={styles.radio__input}
        type="radio"
        value={value}
        onChange={onChange}
        checked={isSelected}
        required
      />
      <div>
        <div>
          <div />
        </div>
      </div>
      <span className={styles.radio__box}>{label}</span>
    </div>
  )
}
export default Radio
